import { createSelector } from 'reselect';
import getQuestionLocationIndex from "../common/getQuestionLocationIndex";
const getQuiz= state => state.quiz;
const getActiveQuestionIndex = state => state.activeQuestionIndex;
/*
Selector
 */
export const getQuestionLocation = createSelector(
    [getQuiz, getActiveQuestionIndex],
    getQuestionLocationIndex
);